<template>
    <section class="renovation-info">
        <h3 class="renovation-info__title">
            {{ renovation.name }}
        </h3>
        <div class="renovation-info__data-item renovation-info__data-item--budget">
            <span class="renovation-info__data-item__label">Budget</span>
            <span class="renovation-info__data-item__value">{{ renovation.budget }}</span>
        </div>
        <div v-if="renovation.cost && !$scheme.priceless"
             class="renovation-info__data-item renovation-info__data-item--cost">
            <span class="renovation-info__data-item__label">Estimated Cost</span>
            <span class="renovation-info__data-item__value">{{ renovation.cost }}</span>
        </div>
        <div class="renovation-info__data-item renovation-info__data-item--improvements">
            <span class="renovation-info__data-item__label --above">Improvements</span>
            <ul class="renovation-info__data-item__value --improvements">
                <li v-for="item in renovation.improvements"
                    :key="item.id">
                    <span class="renovation-info__improvement">{{ item.title }}</span>
                </li>
            </ul>
        </div>
    </section>
</template>

<script>

// TODO: Obsolete component - Delete when Renovations Page replaced with "Thanks"

import Renovation from '@/models/renovation'

export default {

    props: {
        renovation: {
            type: Renovation,
            required: true,
        },
    },
}

</script>


<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\renovations\_renovation-info.scss

.renovation-info {
    display: flex;
    flex-direction: column;

    @include element('title') {
        margin-bottom: 0.2rem;
    }

    @include element('data-item') {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        @include element('label') {
            flex: 1 0 45%;
            font-weight: bold;
            margin-right: 0.5rem;

            &:after {
                content: ':'
            }

            &.--above {
                flex: 0 1 100%;

                &:after {
                    content: '…'
                }
            }
        }

        @include element('value') {
            flex: 1 0 45%;
            text-align: right;

            &.--improvements {
                font-size: 0.9rem;
                @include styled-data-list;
                flex: 0 1 100%;
                text-align: left;
            }
        }
    }
}

</style>
